import React from "react"
import { AuthContext } from "../components/auth/AuthBoundary"

const useAuth = () => React.useContext(AuthContext)
export default useAuth
